import type { ThreadApiResponse } from '../types/thread-api.js';
import { mapThreadResponse } from '../mappers/map-thread-messages.js';

/**
 * Real thread payload (trimmed) — Yeremchuk Dental, GET /api/thread/5753.
 * Used in Storybook to validate mapper + date separators.
 */
export const THREAD_API_SAMPLE: ThreadApiResponse = {
  id: 5753,
  company_id: 11,
  visitor_id: 4846,
  source_id: 300,
  name: 'ываывф',
  is_automated: true,
  sender_id: 'fallback-1769162419904-926302',
  created_at: '2026-01-26T09:01:59.000000Z',
  updated_at: '2026-06-12T11:50:23.000000Z',
  company: {
    id: 11,
    name: 'Yeremchuk Dental',
    ai_manager_name: 'Андрій',
  },
  visitor: {
    id: 4846,
    site_fingerprint_id: 'fallback-1769162419904-926302',
    name: 'ываывф',
    phone: '+383242342342',
  },
  messages: [
    {
      id: 208410,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 3,
      message: 'Доброго дня! Допоможу з записом на консультацію.',
      raw_message: {
        type: 'text',
        payload: 'Доброго дня! Допоможу з записом на консультацію.',
        datetime: '12-06-2026 15:10:00.000 (пт)',
      },
      type: 1,
      like: 0,
      tokens: 0,
      source_id: 300,
      created_at: '2026-06-12T12:10:00.000000Z',
      updated_at: '2026-06-12T12:10:00.000000Z',
    },
    {
      id: 208409,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 1,
      message: 'https://api.aiteo.tech/storage/thread_files/5753/docs/price-list',
      raw_message: {
        type: 'text',
        payload: 'https://api.aiteo.tech/storage/thread_files/5753/docs/price-list',
        datetime: '12-06-2026 15:05:00.000 (пт)',
      },
      type: 4,
      like: 0,
      tokens: 0,
      source_id: 101,
      created_at: '2026-06-12T12:05:00.000000Z',
      updated_at: '2026-06-12T12:05:00.000000Z',
    },
    {
      id: 208408,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 1,
      message: 'https://api.aiteo.tech/storage/thread_files/5753/videos/overview',
      raw_message: {
        type: 'text',
        payload: 'https://api.aiteo.tech/storage/thread_files/5753/videos/overview',
        datetime: '12-06-2026 15:00:00.000 (пт)',
      },
      type: 3,
      like: 0,
      tokens: 0,
      source_id: 101,
      created_at: '2026-06-12T12:00:00.000000Z',
      updated_at: '2026-06-12T12:00:00.000000Z',
    },
    {
      id: 208359,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 2,
      message:
        'https://api.aiteo.tech/storage/thread_files/5753/images/thread_image_6a2bf27e81af4.png',
      raw_message: {
        type: 'image_url',
        payload:
          'https://api.aiteo.tech/storage/thread_files/5753/images/thread_image_6a2bf27e81af4.png',
        datetime: '12-06-2026 14:50:22.750 (пт)',
      },
      type: 2,
      like: 0,
      tokens: 0,
      source_id: 300,
      created_at: '2026-06-12T11:50:22.000000Z',
      updated_at: '2026-06-12T11:50:22.000000Z',
    },
    {
      id: 208356,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 1,
      message:
        'Схоже на гарний настрій) Чим можу допомогти щодо стоматологічних послуг?',
      raw_message: {
        type: 'text',
        payload:
          'Схоже на гарний настрій) Чим можу допомогти щодо стоматологічних послуг?',
        datetime: '12-06-2026 14:49:40.358 (Пт)',
      },
      type: 1,
      like: 0,
      tokens: 10128,
      source_id: 101,
      created_at: '2026-06-12T11:49:40.000000Z',
      updated_at: '2026-06-12T11:49:40.000000Z',
    },
    {
      id: 208355,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 2,
      message: '😀😀😀😀',
      raw_message: {
        type: 'text',
        payload: '😀😀😀😀',
        datetime: '12-06-2026 14:49:34.104 (пт)',
      },
      type: 1,
      like: 0,
      tokens: 0,
      source_id: 300,
      created_at: '2026-06-12T11:49:34.000000Z',
      updated_at: '2026-06-12T11:49:34.000000Z',
    },
    {
      id: 135255,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 1,
      message: 'Що ви мали на увазі?)',
      raw_message: {
        type: 'text',
        payload: 'Що ви мали на увазі?)',
        datetime: '29-01-2026 19:00:33.352 (Чт)',
      },
      type: 1,
      like: 0,
      tokens: 8064,
      source_id: 101,
      created_at: '2026-01-29T17:00:33.000000Z',
      updated_at: '2026-01-29T17:00:33.000000Z',
    },
    {
      id: 135254,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 2,
      message: 'teetre',
      raw_message: {
        type: 'text',
        payload: 'teetre',
        datetime: '29-01-2026 19:00:24.127 (чт)',
      },
      type: 1,
      like: 0,
      tokens: 0,
      source_id: 300,
      created_at: '2026-01-29T17:00:24.000000Z',
      updated_at: '2026-01-29T17:00:24.000000Z',
    },
    {
      id: 129745,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 1,
      message: 'Вітаю! Чим можу допомогти вам сьогодні?',
      raw_message: {
        type: 'text',
        payload: 'Вітаю! Чим можу допомогти вам сьогодні?',
        datetime: '27-01-2026 16:15:46.295 (Вт)',
      },
      type: 1,
      like: 0,
      tokens: 8069,
      source_id: 101,
      created_at: '2026-01-27T14:15:46.000000Z',
      updated_at: '2026-01-27T14:15:46.000000Z',
    },
    {
      id: 127450,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 4,
      message: 'YeremchukDentalFuncs.update_lead_status: Статус ліда оновлено',
      raw_message: {
        type: 'func_result',
        payload: 'YeremchukDentalFuncs.update_lead_status: Статус ліда оновлено',
      },
      type: 6,
      like: 0,
      tokens: 0,
      source_id: 102,
      created_at: '2026-01-26T09:02:08.000000Z',
      updated_at: '2026-01-26T09:02:08.000000Z',
    },
    {
      id: 127446,
      thread_id: 5753,
      lead_follow_up_template_id: null,
      message_role: 2,
      message: 'тест',
      raw_message: {
        type: 'text',
        payload: 'тест',
        datetime: '26-01-2026 11:01:59.146 (пн)',
      },
      type: 1,
      like: 0,
      tokens: 0,
      source_id: 300,
      created_at: '2026-01-26T09:01:59.000000Z',
      updated_at: '2026-01-26T09:01:59.000000Z',
    },
  ],
};

export const THREAD_API_SAMPLE_MESSAGES = mapThreadResponse(THREAD_API_SAMPLE);
